__turbopack_context__.v({
  "className": "polysansmono_3ff6e98d-module__Ra4qUW__className",
  "variable": "polysansmono_3ff6e98d-module__Ra4qUW__variable",
});
